/*==================================================
  PREMIUM PRODUCT STORY
==================================================*/

document.addEventListener("DOMContentLoaded", () => {

  document.querySelectorAll(".pps-section").forEach((section) => {

    const products = [...section.querySelectorAll(".pps-product-slide")];
    const stories = [...section.querySelectorAll(".pps-story")];

    if (!products.length || !stories.length) return;

    const autoplay =
      section.dataset.autoplay !== "false";

    const autoplaySpeed =
      (parseInt(section.dataset.speed) || 5) * 1000;

    let productIndex = 0;
    let stepIndex = 0;

    let timer = null;

    /*==========================================
      PRODUCT
    ==========================================*/

    function renderProduct(index) {

      products.forEach((product, i) => {
        product.classList.toggle("active", i === index);
      });

      stories.forEach((story, i) => {
        story.classList.toggle("active", i === index);
      });

      productIndex = index;
      stepIndex = 0;

      renderStep();

    }

    /*==========================================
      STEP
    ==========================================*/

    function renderStep() {

      const story = stories[productIndex];

      const steps = story.querySelectorAll(".pps-step");
      const dots = story.querySelectorAll(".pps-dots span");

      steps.forEach((step, i) => {
        step.classList.toggle("active", i === stepIndex);
      });

      dots.forEach((dot, i) => {
        dot.classList.toggle("active", i === stepIndex);
      });

    }

    /*==========================================
      NEXT STEP
    ==========================================*/

    function nextStep() {

      const story = stories[productIndex];

      const totalSteps =
        story.querySelectorAll(".pps-step").length;

      if (stepIndex < totalSteps - 1) {

        stepIndex++;

        renderStep();

      } else {

        nextProduct();

      }

    }

    /*==========================================
      PREVIOUS STEP
    ==========================================*/

    function previousStep() {

      if (stepIndex > 0) {

        stepIndex--;

        renderStep();

      } else {

        previousProduct();

      }

    }

    /*==========================================
      NEXT PRODUCT
    ==========================================*/

    function nextProduct() {

      productIndex++;

      if (productIndex >= products.length) {
        productIndex = 0;
      }

      renderProduct(productIndex);

    }

    /*==========================================
      PREVIOUS PRODUCT
    ==========================================*/

    function previousProduct() {

      productIndex--;

      if (productIndex < 0) {
        productIndex = products.length - 1;
      }

      renderProduct(productIndex);

    }

    /*==========================================
      AUTOPLAY
    ==========================================*/

    function stopAuto() {

      clearInterval(timer);

      timer = null;

    }

    function startAuto() {

      if (!autoplay) return;

      stopAuto();

      timer = setInterval(() => {

        nextStep();

      }, autoplaySpeed);

    }

    /*==========================================
      EVENTS
    ==========================================*/

    stories.forEach((story, storyIndex) => {

      const next = story.querySelector(".pps-next");
      const prev = story.querySelector(".pps-prev");

      const dots = story.querySelectorAll(".pps-dots span");

      next.addEventListener("click", () => {

        stopAuto();

        nextStep();

        startAuto();

      });

      prev.addEventListener("click", () => {

        stopAuto();

        previousStep();

        startAuto();

      });

      dots.forEach((dot, index) => {

        dot.addEventListener("click", () => {

          stopAuto();

          productIndex = storyIndex;
          stepIndex = index;

          renderProduct(productIndex);

          stepIndex = index;

          renderStep();

          startAuto();

        });

      });

      story.addEventListener("mouseenter", stopAuto);

      story.addEventListener("mouseleave", startAuto);

    });

    /*==========================================
      INIT
    ==========================================*/

    renderProduct(0);

    startAuto();

  });

});